"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleLink = exports.default = exports.LocaleContext = void 0;
var _react = _interopRequireDefault(require("react"));
var LocaleContext = /*#__PURE__*/_react.default.createContext(undefined);
exports.LocaleContext = LocaleContext;
var getLocaleLink = function getLocaleLink(link, locale) {
  var uri = link;
  var pieces = uri.split('/');
  var country = locale === null || locale === void 0 ? void 0 : locale.country;
  var language = locale === null || locale === void 0 ? void 0 : locale.language;

  // short-circuit if:
  // - locale.country or .language is undefined
  // - uri is undefined or
  // - doesn't start with a slash (relative link) or
  // - doesn't have more than 1 slash
  // - uri already has locale
  if (!country || !language || !uri || uri[0] !== '/' || pieces.length < 2) return uri;
  if (isValidLocaleFormat(pieces[1], pieces[2])) {
    return uri;
  }
  if (isValidLocaleFormat(country, language)) {
    return "/".concat(country, "/").concat(language).concat(uri);
  }
  return uri;
};
exports.getLocaleLink = getLocaleLink;
function isValidLocaleFormat(country, language) {
  return country && language && country.length === 2 && language.length === 2 && country.toUpperCase() === country && language.toLowerCase() === language;
}
var _default = LocaleContext;
exports.default = _default;